<template>
  <p class="mb-2">{{ $t('LOGIN.RESET_PASSWORD_DESC') }}</p>
  <form @submit.prevent="submitResetPassword">
    <v-text-field v-model="password" :placeholder="$t('GLOBAL.PASSWORD')" type="password" prepend-inner-icon="far fa-lock" required autofocus>
    </v-text-field>
    <v-text-field v-model="passwordConfirmation" :placeholder="$t('LOGIN.PASSWORD_CONFIRM')" type="password" prepend-inner-icon="far fa-lock" required class="mt-3">
    </v-text-field>
    <input v-model="token" type="hidden">
    <v-alert :model-value="!! success" type="success" color="successgreen" class="my-2">{{ success }}</v-alert>
    <v-alert :model-value="!! error" type="error" class="mb-2">{{ error }}</v-alert>
    <div class="text-center mt-6">
      <v-btn :disabled="isSubmittingReset" :loading="isSubmittingReset" color="primary" rounded size="large" class="px-12" type="submit">
        {{ $t('LOGIN.CHANGE_PASSWORD') }}
      </v-btn>
    </div>
  </form>
  <div class="mt-12"></div>
  <div class="mt-auto text-center">
    <v-btn variant="text" @click.prevent="$emit('navigate-section', 'register')">{{ $t('LOGIN.CREATE_ACCOUNT') }}</v-btn>
  </div>
</template>

<script>
  export default {
    emits: ['navigate-section'],
    data() {
      return {
        password: "",
        passwordConfirmation: "",
        error: "",
        success: "",
        isSubmittingReset: false,
      };
    },
    computed: {
      token() {
        return this.$route.query.resettoken;
      },
    },
    methods: {
      submitResetPassword() {
        this.error = "";
        this.success = "";
        if (! this.token) {
          this.error = this.$t('LOGIN.ERROR_MISSING_TOKEN');
          return;
        }
        if (this.password !== this.passwordConfirmation) {
          this.error = this.$t('LOGIN.ERROR_PASSWORD_MATCH');
          return;
        }

        this.isSubmittingReset = true;
        window.apiSrv.call('password/reset', 'store', { token: this.token, password: this.password, password_confirmation: this.passwordConfirmation }).then((response) => {
          this.success = response && response.data && response.data.message;
          this.password = "";
          this.passwordConfirmation = "";
          setTimeout(() => { window.location.href = ""; }, 2000);
        }).catch((error) => {
          if (typeof error == 'object') {
            this.error = Object.keys(error).map((key) => {
              const messages = error[key];
              if (Array.isArray(messages)) return `- ${messages.join('\n- ')}`;
              return messages;
            }).join("\n");
          } else {
            this.error = error;
          }
          this.isSubmittingReset = false;
        });
      },
    },
  };
</script>
